/**
 * Ask the browser not to evict the save under storage pressure (content-schemas §11, iOS/Safari eviction).
 * Only for returning players: Firefox shows a permission prompt, which a first-time visitor should not see.
 */
export function requestPersistentStorage(): void {
  if (typeof navigator === 'undefined' || !('storage' in navigator) || !('persist' in navigator.storage))
    return;
  void navigator.storage
    .persisted()
    .then((already) => (already ? true : navigator.storage.persist()))
    .catch(() => false);
}
